/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audit_Logs_Status_Review_RequiredInputs */



/**
* | output |
* | --- |
* | "Review Required" |
*
* @param {Audit_Logs_Status_Review_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_logs_status_review_required = /** @type {((inputs?: Audit_Logs_Status_Review_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Logs_Status_Review_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Überprüfung erforderlich")
	return /** @type {LocalizedString} */ ("Review Required")
});